import {
  Component, Input, OnInit, Output, EventEmitter, OnDestroy,
} from '@angular/core';
import {
  chevronDownIcon, chevronUpIcon, optionsIcon,
} from '../../icon';
import { UIKitIconRegistry } from '../../icon/icon.registry';
import { UIKitIconName } from '../../icon/icon';
import { P } from '../../ui-kit';

export type TableColumnFlex = 'xs' | 's' | 'l' | 'xl';

export interface TableLegend { value: string; class?: string; }

export interface TableCell {
  value: string | number;
  legend?: TableLegend;
  icon?: UIKitIconName;
  event?: string;
  flex?: TableColumnFlex;
  data?: any;
  class?: string;
}

export interface TableRow {
  columns: TableCell[],
  legend?: TableLegend[],
  options?: TableCell[],
  event?: string;
  data?: any;
  // subRows?: TableRow[];
  subTable?: TableData;
  store?: any;
  class?: string;
  checkbox?: boolean;
}

export interface TableHeader {
  label: string;
  legend?: TableLegend;
  sortable?: boolean;
  flex?: TableColumnFlex;
  data?: any;
}

export interface TableData {
  headers: TableHeader[];
  rows: TableRow[];
  hideHeaders?: boolean;
  initialSort?: number;
  collapse?: boolean;
  store?: any;
  eventSubscriber?: any;
}

export interface TableEvent {
  type: string;
  data: any;
}

@Component({
  selector: 'lib-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit, OnDestroy {
  @Input() data: TableData | null | undefined;

  @Input() showHeaders: boolean = true;

  @Output() event: EventEmitter<TableEvent> = new EventEmitter();

  @Input() testAttribute: string | null = null;

  sort: number = -1;

  reverse: boolean | undefined;

  constructor(
    iconRegistry: UIKitIconRegistry,
  ) {
    iconRegistry.registerIcons([
      chevronUpIcon,
      chevronDownIcon,
      optionsIcon,
    ]);
  }

  checkboxes: P.Dictionary<boolean> = {};

  get hasCheckboxes() {
    return this.data?.rows?.some((row) => row.checkbox);
  }

  private onCheckboxChange(id: string) {
    for (const key in this.checkboxes) {
      if (key !== id) {
        this.checkboxes[key] = false;
      }
    }
    this.checkboxes[id] = !this.checkboxes[id];
  }

  ngOnInit(): void {
    if (this.data?.eventSubscriber) {
      this.event.subscribe(this.data.eventSubscriber);
    }
  }

  ngOnDestroy(): void { }

  getFlex(index: number): string {
    const header = this.data?.headers[index];
    return header?.flex || '';
  }

  emitEvent(event: MouseEvent | TouchEvent | null, type: string | undefined = undefined, data: any = undefined): void {
    if (event) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }

    if (type) {
      if (type === 'sort') {
        const newSort = data.index;
        if (this.sort === newSort) {
          this.reverse = !this.reverse;
        } else {
          this.reverse = void 0;
        }
        data.reverse = !!this.reverse;
        this.sort = newSort;
      } else if (type === 'checkbox') {
        this.onCheckboxChange(data);
        data = this.checkboxes[data] ? data : '';
      }

      this.event.emit({ type, data });
    }
  }
}
